import React, { useEffect, useRef, useState } from "react";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import { pageClass, pageHeader } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import { useForm } from "react-hook-form";
import Addmispunch from "../Components/Modals/Addmispunch";
import {GetAllCompanyAPI, GetAllMispunchAPI} from "../API/Api";
import DeleteMispunchModal from "../Components/Modals/DeleteMispunchModal";
import ViewMispunchDetailsModal from "../Components/Modals/ViewMispunchDetailsModal";
import { useSelector } from "react-redux";
import usePaginatedData from "../Components/Utils/UsePagination";
import moment from "moment";
import { IconEye } from "@tabler/icons-react";

export default function Mispunch() {

  const { register } = useForm();
  const themeColor = useThemeColor();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const [mispunchModal, setMispunchModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [Company, setCompany] = useState([]); 
  const filterTimeout = useRef();
  const isFirstRender = useRef(true); 

  const initialFilterState = {
    p: 1,
    userId:userDetails?.role?.roleName !== "SuperAdmin" || userDetails?.role?.roleName !== "Admin" ? "" : userDetails?._id,
    companyId:userDetails?.role?.roleName == "SuperAdmin" ? "" : userDetails?.company?._id
  };

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });

  const {
    filterData: MispunchData,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    loader
  } = usePaginatedData(1, 50, GetAllMispunchAPI, filterObject); 
  

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };


  const HandleViewMispunch = (row) => {
    setRowData(row);
    setMispunchModal(true);
  };



  const getallCompany = async () => {
      try {
        const parentCompanyId = userDetails?.role?.roleName === "SuperAdmin" ? userDetails?.company?._id : "";
        const res = await GetAllCompanyAPI(parentCompanyId);
        setCompany(res?.data?.filteredData);
      } catch (err) {
        console.log("Error:", err);
      }
    }; 

      useEffect(() => {
        getallCompany();
      }, []); 
      
  useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false; // Prevent first API call from `useEffect`
        return;
      }
      filterRecords();
  }, [filterObject]);


  const tableColumns = [
    {
      field: "name",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const firstName = row?.userId?.first_name || "";
        const lastName = row?.userId?.last_name || "";
        const fullName = (firstName && lastName) ? `${firstName} ${lastName}` : firstName || lastName || "-----";
        return <h6>{fullName}</h6>;
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      className: "col-email",
      body: (row) => <h6>{row?.userId?.email ? row?.userId?.email : "row?.userId?.email"}</h6>,
    },
    {
      field: "date",
      header: "Date",
      style: true,
      body: (row) => <h6>{moment(row.date).format("DD-MM-YYYY") ? moment(row.date).format("DD-MM-YYYY") : "-----"}</h6>,
    },
    {
      field: "inTime",
      header: "In Time",
      style: true,
      className: "col-intime",
      body: (row) => <h6>{row?.inTime ? row?.inTime : "-----"}</h6>,
    },
    {
      field: "outTime",
      header: "Out Time",
      style: true,
      className: "col-outtime",
      body: (row) => <h6>{row?.outTime ? row?.outTime : "------"}</h6>,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      className: "col-remark",
      body: (row) => <h6>{row?.remark ? row?.remark :"-----"}</h6>,
    },
    {
      field: "comment",
      header: "Comment",
      style: true,
      className: "col-comment",
      body: (row) => <h6>{row?.comment ? row?.comment : "------"}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      className: "col-actions",
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleViewMispunch(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
            <IconEye stroke={1.5} size={24} className="text-black" color="#000" />
          </button>

          {(userDetails?.role?.roleName === "SuperAdmin" ||
            userDetails?.role?.roleName === "Admin") && (
            <Addmispunch edit={true} rowData={row} filterRecords={filterRecords} Company={Company}/>
          )}

          {(userDetails?.role?.roleName === "SuperAdmin" ||
            userDetails?.role?.roleName === "Admin") && (
            <DeleteMispunchModal rowData={row} filterRecords={filterRecords} />
          )}

        </div>
      ),
    },
  ];

  return (
    <>
      <div className={`${pageClass} mispunch-page`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>Mispunch</h1>
            <div className="flex flex-col sm:flex-row sm:items-center">
              <Addmispunch edit={false} filterRecords={filterRecords} Company={Company} />
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={MispunchData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
          <ViewMispunchDetailsModal mispunchModal={mispunchModal} setMispunchModal={setMispunchModal} data={rowData}/>
        </div>
      </div>
    </>
  );
}